/**
 * Top padding that clears the arch corner so text is not clipped by it.
 *
 * Deliberately NOT in ArchSection.tsx. That file carries "use client", so a
 * constant exported from it becomes a client reference: importing it into a
 * server component and interpolating it into a className stringified to
 * `function(){throw Error("Attempted to call ARCH_CONTENT_CLEARANCE() from the
 * server...")}` and shipped that into the class attribute. A plain module keeps
 * it a plain string on both sides.
 *
 * WHY IT IS NEEDED
 *
 * ArchSection clips its descendants on purpose: at tablet and mobile widths the
 * photography reaches the section edge and the arch curve cutting across it is
 * the intended look (owner, 2026-08-04). The same clip lands on text, so
 * anything near the top of the section has to start below the steep part of the
 * curve or it loses its first characters.
 *
 * The horizontal inset at depth `d` for radius `R` is
 * `R - sqrt(R^2 - (R-d)^2)`. Solving that against each breakpoint's page
 * padding, and against the LARGEST radius each breakpoint reaches rather than
 * its resting one (desktop scrubs 400px up to 1250px as the section rises),
 * gives the values below. Measured against the live DOM, not just derived.
 *
 * Apply to the content wrapper inside an ArchSection unless the section already
 * has more top padding of its own. Sections whose content is centred and narrow
 * (TrustBar) clear the curve without it.
 */
export const ARCH_CONTENT_CLEARANCE = "pt-28 md:pt-52 lg:pt-72";
